import { Box, Group, Stack, Text } from "@mantine/core"
import { WebCalendarProfileDto } from "@/orval/gen"
import { CopyCalendarProfileLinkButton, MoreMenu } from "./more-menu"
import { SubscribeMenuButton } from "./subscribe-menu-button"
import { useIsSmallScreen } from "../../../../../utils/useIsSmallScreen"

interface Props {
  profile: WebCalendarProfileDto
  onEditProfileClick: (profile: WebCalendarProfileDto) => void
}

export function CalendarProfileStackItem({
  profile,
  onEditProfileClick,
}: Props) {
  const isSmallScreen = useIsSmallScreen()
  return (
    <Box
      style={{
        display: "grid",
        alignItems: "start",
        gridTemplateColumns: isSmallScreen
          ? "minmax(0, 1fr) auto"
          : "minmax(0, 1fr) auto auto",
        gridTemplateAreas: isSmallScreen
          ? '"details menu" "actions actions"'
          : '"details actions menu"',
        columnGap: "var(--mantine-spacing-xs)",
        rowGap: "var(--mantine-spacing-xs)",
      }}
    >
      <Stack
        gap={4}
        miw={0}
        style={{ gridArea: "details", overflowWrap: "anywhere" }}
      >
        <Text fw={500}>{profile.name}</Text>
        {profile.description && (
          <Text size="sm" c="dimmed">
            {profile.description}
          </Text>
        )}
      </Stack>
      <Group gap="xs" style={{ gridArea: "actions" }}>
        <SubscribeMenuButton profile={profile} />
        {profile.isSubsribed && !isSmallScreen && (
          <CopyCalendarProfileLinkButton component="Button" profile={profile} />
        )}
      </Group>
      {(profile.isSubsribed || profile.allowEditAndDelete) && (
        <Box style={{ gridArea: "menu" }}>
          <MoreMenu onEditProfileClick={onEditProfileClick} profile={profile} />
        </Box>
      )}
    </Box>
  )
}
